import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["generated", "referenceFrame", "notGenerated", "selectedOption", "imageOptions"]

  connect() {
    // Attach event listeners to all radio button targets
    this.generatedTargets.forEach(target => {
      target.addEventListener("change", this.handleGeneratedChange.bind(this));
    });

    // Initialize the state of the generated fields
    const checkedValue = this.generatedTargets.find(target => { return (target.type === 'radio' && target.checked) || target.type === 'hidden' })?.value;
    this.toggleGeneratedFields(checkedValue);

    this.highlightSelectedOption();
  }

  disconnect() {
    // Cleanup listeners on disconnect
    this.generatedTargets.forEach(target => {
      target.removeEventListener("change", this.handleGeneratedChange.bind(this));
    });
  }

  handleGeneratedChange(event) {
    this.toggleGeneratedFields(event.target.value);
  }

  handleClick(event) {
    this.selectedOptionTarget.value = event.params.id;
    this.highlightSelectedOption();
  }

  highlightSelectedOption() {
    this.imageOptionsTargets.forEach((target, i) => {
      if (i === parseInt(this.selectedOptionTarget.value)) target.classList.remove("opacity-50");
      else target.classList.add("opacity-50");
    });
  }

  toggleGeneratedFields(value) {
    if (value === "true") {
      this.referenceFrameTarget.classList.remove("hidden");
      if (this.hasNotGeneratedTarget) this.notGeneratedTarget.classList.add("hidden");
    } else {
      this.referenceFrameTarget.classList.add("hidden");
      if (this.hasNotGeneratedTarget) this.notGeneratedTarget.classList.remove("hidden");
    }
  }
}